<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import DesignFeedCartIcon from "@apps/iloom_customization/design_feed/components/icons/DesignFeedCartIcon.svelte";
    import { MediaProductEntity } from "@apps/iloom_customization/design_feed/entities/MediaEntity";
    import { CartQuery } from "@modules/cart/queries/CartQuery";
    import { CartService } from "@modules/cart/services/CartService";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { map } from "rxjs";
    import { container } from "tsyringe";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Button from "@components/Buttons/Button.svelte";
    import Spinner from "@components/Spinner/Spinner.svelte";

    export let cartQuery: CartQuery;
    export let cartService: CartService;
    export let product: MediaProductEntity;

    const urlsBuilder = container.resolve(CommonModule).exports.urlsBuilder;

    const cartStatus$ = cartQuery.selectEditItemStatus(product.variantId);

    const itemInCartStatus$ = cartQuery
        .selectQuantityByVariantId(product.variantId)
        .pipe(map((quantity) => quantity > 0));

    const handleAddToCart = () => {
        if ($itemInCartStatus$) return;
        cartService.addToCart([
            {
                variantID: product.variantId,
                quantity: 1,
            },
        ]);
    };
</script>

{#if $cartStatus$ === STATUS.LOADING}
    <Spinner size="18px" />
{:else if !$itemInCartStatus$}
    <BaseButton on:click={handleAddToCart}>
        <DesignFeedCartIcon />
    </BaseButton>
{:else if $itemInCartStatus$}
    <Button url={urlsBuilder.createCartUrl()}>Show in Cart</Button>
{/if}
